export enum AuthenticationProvider {
  Google = "google",
  Microsoft = "microsoft",
}
